import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '~/app/store'
import { IEFManagementLicense } from '~/models'
import { isJsonString } from '~/utils'

const initialState: IEFManagementLicense = isJsonString(
  localStorage.getItem('managementLicense') as string
)
  ? JSON.parse(localStorage.getItem('managementLicense') as string)
  : {
      isLicensedForDeveloperOnly: false,
      isLicensedForOtap: false,
      isLicensedForBaseStation: false
    }

const LicenseSlice = createSlice({
  name: 'managementLicense',
  initialState,
  reducers: {
    setManagementLicense: (state, action: PayloadAction<IEFManagementLicense>) => {
      state.isLicensedForDeveloperOnly = action.payload.isLicensedForDeveloperOnly
      state.isLicensedForOtap = action.payload.isLicensedForOtap
      state.isLicensedForBaseStation = action.payload.isLicensedForBaseStation
      localStorage.setItem('managementLicense', JSON.stringify(state))
    }
  }
})

export const managementLicense = (state: RootState) => state.managementLicence
export const setManagementLicense = LicenseSlice.actions.setManagementLicense

export default LicenseSlice.reducer
